class KlevuProduct extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.BAO.sectionRenderer
      .fetch('klevu-product', this.getAttribute('data-url'))
      .then(res => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res['klevu-product'],
        )
        const myself = newDOM.querySelector('article')

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }
}

if (!customElements.get('klevu-product')) {
  customElements.define('klevu-product', KlevuProduct)
}
